import { supabase, uid } from './shared'
import type { BotCreateData, BotUpdateData } from '../../contract'

export async function getBots() {
  const userId = await uid();
  const { data, error } = await supabase
    .from('bots')
    .select('*')
    .eq('user_id', userId)
    .order('is_default', { ascending: false })
    .order('id', { ascending: true });

  if (error) throw error;
  return { bots: data ?? [] };
}

export async function createBot(botData: BotCreateData) {
  const userId = await uid();
  const payload = {
    ...botData,
    user_id: userId,
  };
  const { error } = await supabase.from('bots').insert(payload);
  if (error) throw error;
  return { message: 'Bot created successfully' };
}

export async function updateBot(id: number | string, botData: BotUpdateData) {
  const userId = await uid();
  const { error } = await supabase
    .from('bots')
    .update(botData)
    .eq('id', id)
    .eq('user_id', userId);

  if (error) throw error;
  return { message: 'Bot updated successfully' };
}

export async function deleteBot(id: number | string) {
  const userId = await uid();
  const { error } = await supabase
    .from('bots')
    .delete()
    .eq('id', id)
    .eq('user_id', userId);

  if (error) throw error;
  return { message: 'Bot deleted successfully' };
}

export async function setDefaultBot(id: number | string) {
  const userId = await uid();

  const { error: unsetErr } = await supabase
    .from('bots')
    .update({ is_default: false })
    .eq('user_id', userId)
    .eq('is_default', true);
  if (unsetErr) throw unsetErr;

  const { error: setErr } = await supabase
    .from('bots')
    .update({ is_default: true })
    .eq('id', id)
    .eq('user_id', userId);
  if (setErr) throw setErr;

  return { message: 'Default bot updated successfully' };
}
